<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-pt-4 p-d-flex p-jc-center">Ativação do Dispositivo</h5>
                    <p>					
                        Digite o código do empregador e o código de ativação para ativar a marcação online.
                    </p>   
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="codigoEmpresa" type="text" placeholder="Código Empregador"/>                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroCodigoEmpresa">Informe o código do empregador</small>  
                    </div>               
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="codigoAtivacao" type="text" placeholder="Código Ativação"/>                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroCodigoAtivacao">Informe o código de ativação</small>  
                    </div>      
                    <div class="p-grid p-d-flex p-jc-between">
                        <div class="p-col-6 p-text-left">
                            <a href="/login" class="text-help">Login</a> 
                        </div>
                        <div class="p-col-6 p-text-right">
                            <a href="/esqueci-senha" class="text-help">Esqueceu a senha?</a> 
                        </div>                        
                    </div>                                  
                    <div class="p-grid p-mt-3 p-mb-4">
                        <div class="p-col-12">
                            <Button label="Enviar" @click="enviar"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="exibirErro">{{ mensagemErro }}</Message>
                    <Message severity="info" v-if="exibirSucesso">{{ mensagemSucesso }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import DispositivoService from '@/service/DispositivoService';

export default {
    dispositivoService: null,
    data() {
        return {
            exibirSpin: false,       
            exibirErroCodigoAtivacao: false,    
            exibirErroCodigoEmpresa: false,     
            mensagemErro: '',
            mensagemSucesso: '',
            exibirSucesso: false,
            exibirErro: false,        
            codigoEmpresa: '',
            codigoAtivacao: ''
        }
    },    
    methods: {
        enviar() {
            this.exibirSpin = true;
            this.exibirErro = false;         
            this.exibirSucesso = false;
            this.mensagemSucesso = '';
            this.mensagemErro = '';   
            if(this.codigoAtivacao == '') {
                this.exibirErroCodigoAtivacao = true;
            } 
            if(this.codigoEmpresa == '') {
                this.exibirErroCodigoEmpresa = true;
            }            
            if(!this.exibirErroCodigoAtivacao && !this.exibirErroCodigoEmpresa) {         
                let dados = {
                    codigoEmpresa: this.codigoEmpresa,
                    codigoAtivacao: this.codigoAtivacao
                }   
                this.dispositivoService.validar(dados)
                    .then(resp => {                     
                        this.exibirSpin = false;                     
                        sessionStorage.setItem('SUCESSO_ATIVACAO', JSON.stringify(resp.data));
                        this.$router.push({ path: '/ativar' }); 
                    })
                    .catch(erro => {                    
                        this.exibirSpin = false;                 
                        this.exibirErro = true;
                        if(erro.response.status == 400) {
                            this.mensagemErro = erro.response.data.mensagem;
                        } else {
                            this.mensagemErro = erro.response.data.mensagem;
                        }
                    });               
            } else {
                this.exibirSpin = false;
            }           
        }       
    },
    created() {
        this.dispositivoService = new DispositivoService();       
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>